/// <amd-module name="Core/Medius.Core.Web/Scripts/Candu/canduTracker" />

import { getGlobalId } from "../Medius/lib/utils/user";

function getCandu() {
    return (window as any).Candu;
}

/**
 * 
Fires task_updated in Candu and refreshes the membership afterwards. */
export function trackTaskUpdated(): void {
    const candu = getCandu();
    candu?.getEventing().track("task_updated").then(() => candu?.refreshMembership());
}

/**
 *
Fires task_completed in Candu and refreshes the membership afterwards. */
export function trackTaskCompleted(): void {
    const candu = getCandu();
    candu?.getEventing().track("task_completed").then(() => candu?.refreshMembership());
}

export function setNewInboxState(state: boolean): void {
    const candu = getCandu();
    if (candu) {
        candu.getEventing().identify(getGlobalId(), {"newInboxEnabled": state}).then(() => candu?.refreshMembership());
    }
}

export default { trackTaskUpdated, trackTaskCompleted };